'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _components2 = require('components');

var _OrderListItemView = require('./OrderListItemView');

var _OrderListItemView2 = _interopRequireDefault(_OrderListItemView);

require('./OrderList.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    OrderListView: {
        displayName: 'OrderListView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Personal/OrderList/default/OrderListView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var OrderListView = _wrapComponent('OrderListView')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        lang: state.lang,
        currency: state.currency
    };
}, { push: _reactRouterRedux.push }), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(OrderListView, _Component);

    function OrderListView() {
        (0, _classCallCheck3.default)(this, OrderListView);
        return (0, _possibleConstructorReturn3.default)(this, (OrderListView.__proto__ || (0, _getPrototypeOf2.default)(OrderListView)).apply(this, arguments));
    }

    (0, _createClass3.default)(OrderListView, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var orders = this.props.orders || [];
            var _props = this.props,
                activePage = _props.activePage,
                limit = _props.limit,
                count = _props.count,
                handleChangePage = _props.handleChangePage,
                lang = _props.lang,
                currency = _props.currency;


            if (orders.length === 0) {
                return _react3.default.createElement(
                    'section',
                    { id: 'category-grid' },
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-9' },
                        _react3.default.createElement(
                            'div',
                            { className: 'grid-list-orders' },
                            _react3.default.createElement(
                                'h2',
                                { className: 'section-title' },
                                lang['store.order_list.order_list']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'empty-block' },
                                lang['store.order_list.empty_list']
                            )
                        )
                    )
                );
            }

            return _react3.default.createElement(
                'section',
                { id: 'category-grid' },
                _react3.default.createElement(
                    'div',
                    { className: 'grid-list-orders' },
                    _react3.default.createElement(
                        'h2',
                        { className: 'section-title' },
                        lang['store.order_list.order_list']
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'products-grid' },
                        _react3.default.createElement(
                            'div',
                            { className: 'orders-list' },
                            orders.map(function (item) {
                                return _react3.default.createElement(_OrderListItemView2.default, {
                                    key: item.id,
                                    order: item,
                                    onPay: function onPay(event) {
                                        _this2.props.onPay(item);
                                    },
                                    lang: lang,
                                    currency: currency
                                });
                            })
                        ),
                        _react3.default.createElement(_components2.Paginator, {
                            activePage: activePage,
                            limit: limit,
                            count: count,
                            handleChangePage: handleChangePage
                        })
                    )
                )
            );
        }
    }]);
    return OrderListView;
}(_react2.Component), _class2.propTypes = {
    orders: _react2.PropTypes.array,
    onPay: _react2.PropTypes.func,
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object
}, _class2.defaultProps = {
    onPay: function onPay() {}
}, _temp)) || _class));

exports.default = OrderListView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Personal/OrderList/default/OrderListView.jsx
// module id = 1831
// module chunks = 0